
import $ from 'jquery'

export default {
  name: 'inventaire',
  components: {},
  props: [],
  data () {
    return {
        perPage: 10,
        filter: '',
        fields: ['libelle','stock', 'debut', 'actions'],
        currentPage: 1,
    }
  },
  computed: {
    inventaires() {
        return this.$store.getters['inventaires']
    },
  },

  mounted () {
    setTimeout(() => {
        $('.p-content').fadeIn();
    }, 500);

    this.$store.dispatch("getInventaires");

  },
  methods: {

  }
}


